<template>
    <div
        class="flex h-screen overflow-hidden drafting-page-container"
        :class="{
            'flex-col anonymous': !isLoggedIn
        }"
    >
        <div v-if="isLoggedIn" class="flex flex-shrink-0">
            <NavBar />
        </div>
        <template v-else>
            <HeaderBar />
        </template>
        <div class="flex-1 overflow-y-auto">
            <router-view />
        </div>
        <AdminFloatingBar />
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import NavBar from '@/components/Nav/NavBar.vue';
import HeaderBar from './components/Nav/HeaderBar.vue';
import AdminFloatingBar from '@/components/AdminFloatingBar.vue';
import { useAISettings } from '@/features/ai-settings';
import { useUserLogin } from '@eureka/shared/src/login-sdk/src/composables/useUserLogin';

// 预加载AI设置
const { loadSettings } = useAISettings();
const { isLoggedIn } = useUserLogin();

onMounted(() => {
    // 应用启动时加载AI设置，提前获取用户偏好
    loadSettings().catch((err) => {
        console.warn('Failed to preload AI settings:', err);
        // 失败不影响应用正常运行，会使用默认值
    });
});
</script>

<style lang="scss">
.drafting-page-container {
    &.anonymous {
        .patent-drafting-page {
            height: calc(100vh - 65px); // 减去顶部提示栏高度
        }
    }
}
</style>
